module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Waltenschwil-a8421a894df800efb3fca8e8476d92cd.svg";